// extracted by mini-css-extract-plugin
module.exports = {"hover":"Index_hover__ZNBAM"};